export default class App {
    constructor() {
        // We houden de variabelen bij binnen de class (this)
        this.items = [];
        this.lightbox = null;
        this.lightboxImg = null;
        this.closeBtn = null;
        this.prevBtn = null;
        this.nextBtn = null;
        this.currentIndex = 0;
        this.imagesList = [];
    }

    // Dit is de init methode die je in je hoofdscript aanroept
    async init() {
        // Selecteer alle elementen
        this.items = document.querySelectorAll('.masonry-item');
        this.lightbox = document.getElementById('lightbox');
        this.lightboxImg = document.getElementById('lightbox-img');
        this.closeBtn = document.getElementById('lightbox-close');
        this.prevBtn = document.getElementById('lightbox-prev');
        this.nextBtn = document.getElementById('lightbox-next');

        // Als de cruciale lightbox elementen niet bestaan op de pagina, stop dan om errors te voorkomen
        if (!this.lightbox || !this.lightboxImg) {
            console.warn("Lightbox elementen niet gevonden op deze pagina.");
            return;
        }

        this.setupLightbox();
        this.setupEventListeners();
    }

    // 1. Verzamel alle afbeeldingen uit de masonry en zet de kliks klaar
    setupLightbox() {
        // AANGEPAST: Arrow function gebruiken zodat 'this' bruikbaar blijft
        this.items.forEach((item, index) => {
            const img = item.querySelector('img');
            if (img) {
                // GEERIGEERD: 'this.' toegevoegd voor imagesList
                const fullSrc = img.getAttribute('data-full');
                this.imagesList.push(fullSrc);
                
                item.addEventListener('click', () => {
                    // GEERIGEERD: Overal 'this.' voor gezet zodat het naar de class-variabelen en methoden wijst
                    this.currentIndex = index;
                    this.openLightbox(this.imagesList[this.currentIndex]);
                });
            }
        });
    }

    // 2. Open functie
    openLightbox(src) {
        this.lightboxImg.src = src;
        this.lightbox.classList.add('active');
        document.body.style.overflow = 'hidden'; // Voorkom scrollen op de achtergrond
    }

    // 3. Sluit functie
    closeLightbox() {
        this.lightbox.classList.remove('active');
        document.body.style.overflow = ''; // Herstel scrollen
    }

    // 4. Navigatie functies
    showNext() {
        this.currentIndex = (this.currentIndex + 1) % this.imagesList.length;
        this.lightboxImg.src = this.imagesList[this.currentIndex];
    }

    showPrev() {
        this.currentIndex = (this.currentIndex - 1 + this.imagesList.length) % this.imagesList.length;
        this.lightboxImg.src = this.imagesList[this.currentIndex];
    }

    // 5. Alle Event Listeners netjes gebundeld
    setupEventListeners() {
        // Klik op kruisje
        if (this.closeBtn) {
            this.closeBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.closeLightbox();
            });
        }

        // Klik op pijlen
        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.showNext();
            });
        }
        
        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.showPrev();
            });
        }

        // Klik OP de witte overlay sluit de lightbox
        this.lightbox.addEventListener('click', (e) => {
            if (e.target === this.lightbox || e.target === document.querySelector('.lightbox-content')) {
                this.closeLightbox();
            }
        });

        // Toetsenbord navigatie (Pijltjes + Escape)
        document.addEventListener('keydown', (e) => {
            if (!this.lightbox.classList.contains('active')) return;

            if (e.key === 'ArrowRight') {
                this.showNext();
            } else if (e.key === 'ArrowLeft') {
                this.showPrev();
            } else if (e.key === 'Escape') {
                this.closeLightbox();
            }
        });
    }
}